import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ImageGallery from "react-image-gallery";
import axios from "axios";
import { getContent } from "../../../utils/main";

const Images = () => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const content = useSelector((state) => state.mainSlice.content);
  const [imagesLoading, setImagesLoading] = useState(true);
  const [images, setImages] = useState([]);

  useEffect(() => {
    setImagesLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/multimedia/images/`)
      .then((res) => {
        var localImages = [];
        for (var i = 0; i < res.data.length; i++) {
          localImages.push({
            original: process.env.REACT_APP_API_URL + res.data[i].src,
            thumbnail: process.env.REACT_APP_API_URL + res.data[i].src_thumb,
            description:
              lang === "en"
                ? res.data[i].name_en
                : lang === "ru"
                ? res.data[i].name_ru
                : res.data[i].name_tm,
          });
        }
        setImages([...[], ...localImages]);
      })
      .catch(() => {
        setImages([]);
      })
      .finally(() => {
        setImagesLoading(false);
      });
  }, [lang]);

  return (
    <div className="row py-5">
      <div className="col-12">
        <h4 className="fw-bold">{getContent(content, "Images", lang)}</h4>
      </div>
      <div className="col-12">
        {imagesLoading === true ? (
          "Loading... "
        ) : images.length !== 0 ? (
          <div className="gallery mt-2">
            <ImageGallery items={images} />
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Images;
